import { auth, db } from "../../../firebaseConfig"; // Make sure to import your Firebase configuration
import { doc, setDoc } from "firebase/firestore";
import { getSelectedUid } from "../../../../frontend/Recruitment/Applications/Utils/UidListener";

// Function to save form data for Section 2
export const writeDataS4 = async (formData) => {
  // console.log("Form data for Section 4: ", formData);
  const userId = getSelectedUid(); // Get the selected UID
  if (!userId) {
    throw new Error("Invalid user.");
  }
  try {
    const docRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Company Directorships"
    );

    await setDoc(
      docRef,
      {
        ...formData,
      },
      { merge: true }
    );
    // console.log("Section 4 data successfully written to Firestore!");
  } catch (error) {
    // console.error("Error writing Section 4 data to Firestore: ", error);
  }
};
